// 開発/プレビュー用ロール切替バナー。
// ローカル開発(import.meta.env.DEV) か、サーバが dev ログインを許可している
// プレビュー環境(devLoginAvailable)でのみ表示。本番(Access＋フラグ未設定)では出ない。
import { DEV_USERS, getDevUser, setDevUser } from "../lib/session";
import { useAuth } from "../auth";
import { t } from "../i18n/zh-TW";

export function DevRoleSwitcher() {
  const { reload, devLoginAvailable } = useAuth();
  if (!import.meta.env.DEV && !devLoginAvailable) return null;
  const current = getDevUser();

  function onChange(email: string) {
    setDevUser(email);
    reload();
  }

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-amber-900">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-2 text-sm">
        <span className="font-medium">{t.dev.bannerLabel}</span>
        <select
          value={current}
          onChange={(e) => onChange(e.target.value)}
          className="rounded-md border border-amber-300 bg-white px-2 py-1 text-sm"
        >
          {DEV_USERS.map((u) => (
            <option key={u.email} value={u.email}>
              {u.label}
            </option>
          ))}
        </select>
        <span className="text-xs text-amber-700">{t.dev.note}</span>
      </div>
    </div>
  );
}
